import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../lib/AuthContext'

const LogoSVG = () => (
  <svg viewBox="0 0 226 38" width="178" height="32" xmlns="http://www.w3.org/2000/svg" style={{ display: 'block' }}>
    <circle cx="14" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
    <circle cx="24" cy="25" r="10" fill="none" stroke="var(--accent)" strokeWidth="3.5"/>
    <text x="41" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--text)">Fit</text>
    <text x="87" y="30" fontFamily="Syne, sans-serif" fontWeight="800" fontSize="19" fill="var(--accent)">Progress</text>
  </svg>
)

/**
 * TopBar principale — usata su tutte le pagine.
 * Props:
 *   onNotifiche: () => void  — apre PaginaNotifiche (mostra campanella)
 *   onIndietro:  () => void  — mostra freccia ← a sinistra (viste secondarie)
 */
export default function TopBar({ onNotifiche, onIndietro }) {
  const { esci, profilo } = useAuth()
  const [nonLette, setNonLette] = useState(0)

  useEffect(() => {
    if (!profilo?.id) return
    contaNotifiche()
    const interval = setInterval(contaNotifiche, 60000)

    // Realtime: aggiorna badge subito quando arriva nuova notifica
    const channel = supabase
      .channel('topbar_notifiche_' + profilo.id)
      .on('postgres_changes', {
        event: 'INSERT',
        schema: 'public',
        table: 'notifiche',
        filter: `utente_id=eq.${profilo.id}`,
      }, () => contaNotifiche())
      .subscribe()

    return () => {
      clearInterval(interval)
      supabase.removeChannel(channel)
    }
  }, [profilo?.id])

  async function contaNotifiche() {
    const { count } = await supabase
      .from('notifiche')
      .select('*', { count: 'exact', head: true })
      .eq('utente_id', profilo.id)
      .eq('letta', false)
    setNonLette(count || 0)
  }

  useEffect(() => {
    window.__topBarAggiorna = contaNotifiche
    return () => { delete window.__topBarAggiorna }
  })

  return (
    <div className="topbar" style={{ display: 'grid', gridTemplateColumns: '40px 1fr auto', alignItems: 'center' }}>
      {/* Sinistra: freccia indietro o spazio vuoto */}
      <div>
        {onIndietro && (
          <button onClick={onIndietro} className="back-btn" aria-label="Indietro">←</button>
        )}
      </div>

      {/* Centro: logo sempre visibile */}
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <LogoSVG />
      </div>

      {/* Destra: campanella + Esci */}
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', justifyContent: 'flex-end' }}>
        {onNotifiche && (
          <button
            onClick={onNotifiche}
            style={{ background: 'none', border: 'none', cursor: 'pointer', position: 'relative', padding: 4 }}
          >
            <span style={{ fontSize: 20 }}>🔔</span>
            {nonLette > 0 && (
              <span style={{
                position: 'absolute', top: 0, right: 0,
                background: 'var(--accent)', color: '#000',
                borderRadius: '50%', width: 16, height: 16,
                fontSize: 10, fontWeight: 700,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                {nonLette > 9 ? '9+' : nonLette}
              </span>
            )}
          </button>
        )}
        <button
          onClick={esci}
          style={{ background: 'none', border: 'none', color: 'var(--muted)', cursor: 'pointer', fontSize: 13, fontFamily: 'Syne', fontWeight: 600 }}
        >
          Esci
        </button>
      </div>
    </div>
  )
}
